import { useState } from 'react';

export default function Services() {
  const [activeService, setActiveService] = useState(0);

  const services = [
    {
      icon: 'ri-road-map-line',
      title: 'Driveway Sealcoating',
      subtitle: 'Residential Protection',
      description: 'Professional asphalt emulsion sealcoating that creates a protective barrier against water, UV rays, and chemicals. Extends driveway life by 3-5 years.',
      features: ['Premium asphalt emulsion sealers','UV protection coating','Water damage prevention','2-coat application system','Professional equipment','24-hour curing process'],
      price: 'Starting at $0.20/sq ft'
    },
    {
      icon: 'ri-building-2-line',
      title: 'Commercial Lot Sealcoating',
      subtitle: 'Business & HOA Lots',
      description: "Protect your business's first impression. We sealcoat parking lots for offices, retail centers, restaurants, HOAs, and multi-unit properties throughout the Lakes Area. We work around your schedule — early mornings, evenings, or weekends — so your business keeps moving.",
      features: ['Offices, retail & restaurant lots','HOAs & multi-unit properties','Flexible scheduling','Free quotes on any lot size','Extends pavement life','Prevents costly cracking'],
      price: 'Free quotes on any lot size'
    },
    {
      icon: 'ri-layout-grid-line',
      title: 'Parking Lot Striping',
      subtitle: 'Sharp, Code-Compliant Lines',
      description: 'Sharp, straight, code-compliant lines. We handle full restriping and new layouts for parking stalls, ADA-accessible spaces, fire lanes, directional arrows, and curb markings. Available as an add-on to sealcoating jobs or as standalone service.',
      features: ['Parking stalls & ADA spaces','Fire lanes & directional arrows','New layouts & full restriping','Curb markings','Standalone or add-on','Code-compliant layouts'],
      price: 'Call for quote'
    },
    {
      icon: 'ri-hammer-line',
      title: 'Crack Filling',
      subtitle: 'Structural Repair',
      description: 'Professional crack filling prevents water infiltration and freeze-thaw damage, extending the life of your asphalt and creating a smooth surface ready for sealing.',
      features: ['Hot rubberized crack filler','Prevents water infiltration','Stops freeze-thaw damage','Smooth surface finish','Works with any crack size','Long-lasting results'],
      price: 'Included in packages'
    },
    {
      icon: 'ri-brush-line',
      title: 'Full Maintenance Package',
      subtitle: 'Complete Care',
      description: 'Our all-in-one package combines crack filling and sealcoating for maximum protection. The best value for driveways that need comprehensive care.',
      features: ['Full driveway inspection','Complete crack filling','Surface preparation','Premium sealer application','Quality assurance check','Complete cleanup'],
      price: 'Best value — ask for quote'
    }
  ];

  return (
    <section id="services" className="py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10">
          <div className="text-orange-500 font-display font-bold text-lg uppercase tracking-widest mb-3">What We Do</div>
          <h2 className="font-display text-6xl md:text-7xl font-bold text-white uppercase mb-6">Our Services</h2>
          <p className="text-xl text-gray-400 max-w-3xl">
            From single-family driveways to commercial parking lots, we sealcoat and stripe pavement that lasts. Locally owned and operating throughout Lake Geneva and the surrounding Lakes Area, we treat every job — big or small — like it's our own property.
          </p>
        </div>

        <div className="mb-10 bg-orange-500/10 border border-orange-500/30 rounded-xl p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <div className="w-12 h-12 bg-orange-500 rounded-xl flex items-center justify-center flex-shrink-0">
            <i className="ri-building-2-line text-white text-xl"></i>
          </div>
          <div className="flex-1">
            <div className="text-white font-bold text-lg">Now serving commercial clients!</div>
            <div className="text-gray-400 text-sm">Parking lots, HOAs, retail centers, and multi-unit properties throughout Walworth County.</div>
          </div>
          <a href="#contact" className="flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white px-5 py-2.5 rounded font-semibold text-sm transition-all whitespace-nowrap">
            Get Commercial Quote <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 mb-20">
          <div className="lg:col-span-2 flex flex-col gap-3">
            {services.map((s, i) => (
              <button key={i} onClick={() => setActiveService(i)}
                className={`flex items-center gap-4 p-5 rounded-xl text-left transition-all duration-300 border ${activeService === i ? 'bg-orange-500 border-orange-500 text-white shadow-lg shadow-orange-500/20' : 'bg-white/5 border-white/10 text-gray-300 hover:bg-white/10'}`}>
                <div className={`w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0 ${activeService === i ? 'bg-white/20' : 'bg-white/10'}`}>
                  <i className={`${s.icon} text-xl`}></i>
                </div>
                <div>
                  <div className="font-display font-bold text-lg uppercase">{s.title}</div>
                  <div className={`text-sm ${activeService === i ? 'text-orange-200' : 'text-gray-500'}`}>{s.subtitle}</div>
                </div>
              </button>
            ))}
          </div>

          <div className="lg:col-span-3 bg-white/5 border border-white/10 rounded-2xl p-8">
            <h3 className="font-display text-4xl font-bold text-white uppercase mb-2">{services[activeService].title}</h3>
            <p className="text-orange-500 font-semibold mb-6">{services[activeService].subtitle}</p>
            <p className="text-gray-300 mb-8 leading-relaxed text-lg">{services[activeService].description}</p>
            <div className="grid grid-cols-2 gap-3 mb-8">
              {services[activeService].features.map((f, i) => (
                <div key={i} className="flex items-center gap-2 text-gray-300">
                  <i className="ri-check-line text-orange-500 flex-shrink-0"></i>
                  <span className="text-sm">{f}</span>
                </div>
              ))}
            </div>
            <div className="flex items-center justify-between pt-6 border-t border-white/10">
              <div className="text-orange-400 font-bold text-lg">{services[activeService].price}</div>
              <a href="#contact" className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded-lg font-bold transition-all inline-flex items-center gap-2">
                Get Quote <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mb-20">
          <h3 className="font-display text-4xl font-bold text-white uppercase mb-8 flex items-center gap-3">
            <span className="w-8 h-1 bg-orange-500 inline-block rounded"></span>
            Commercial Services
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden hover:border-orange-500/40 transition-all duration-300">
              <div className="relative h-52 overflow-hidden">
                <img src="/commercial1.jpg" alt="Commercial lot sealcoating by Lakes Area Sealcoating" className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                <div className="absolute top-4 left-4 bg-orange-500 text-white text-xs font-bold px-3 py-1.5 rounded-full uppercase">Commercial</div>
                <div className="absolute bottom-3 right-3 bg-green-500 text-white text-xs font-bold px-2 py-1 rounded-full">Our Work</div>
              </div>
              <div className="p-7">
                <div className="w-12 h-12 bg-orange-500/20 border border-orange-500/30 rounded-xl flex items-center justify-center mb-4">
                  <i className="ri-building-2-line text-orange-400 text-xl"></i>
                </div>
                <h4 className="font-display text-2xl font-bold text-white uppercase mb-3">Commercial Lot Sealcoating</h4>
                <p className="text-gray-400 text-sm leading-relaxed mb-5">
                  Protect your business's first impression. We sealcoat parking lots for offices, retail centers, restaurants, HOAs, and multi-unit properties throughout the Lakes Area. We work around your schedule — early mornings, evenings, or weekends — so your business keeps moving. Free quotes on lots of any size.
                </p>
                <div className="space-y-2 mb-6">
                  {['Offices, retail & restaurant lots','HOAs & multi-unit properties','Flexible scheduling around your business','Free quotes on any lot size'].map((f,i) => (
                    <div key={i} className="flex items-center gap-2 text-gray-300 text-sm">
                      <i className="ri-checkbox-circle-line text-orange-500 flex-shrink-0"></i>{f}
                    </div>
                  ))}
                </div>
                <a href="#contact" className="text-orange-500 hover:text-orange-400 font-bold text-sm flex items-center gap-2 transition-colors">
                  Get Free Quote <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>

            <div className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden hover:border-orange-500/40 transition-all duration-300">
              <div className="relative h-52 overflow-hidden">
                <img src="/striping.jpg" alt="Parking lot and court striping by Lakes Area Sealcoating" className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                <div className="absolute top-4 left-4 bg-orange-500 text-white text-xs font-bold px-3 py-1.5 rounded-full uppercase">Striping</div>
                <div className="absolute bottom-3 right-3 bg-green-500 text-white text-xs font-bold px-2 py-1 rounded-full">Our Work</div>
              </div>
              <div className="p-7">
                <div className="w-12 h-12 bg-orange-500/20 border border-orange-500/30 rounded-xl flex items-center justify-center mb-4">
                  <i className="ri-layout-grid-line text-orange-400 text-xl"></i>
                </div>
                <h4 className="font-display text-2xl font-bold text-white uppercase mb-3">Parking Lot Striping</h4>
                <p className="text-gray-400 text-sm leading-relaxed mb-5">
                  Sharp, straight, code-compliant lines. We handle full restriping and new layouts for parking stalls, ADA-accessible spaces, fire lanes, directional arrows, and curb markings. Available as an add-on to sealcoating jobs or as standalone service.
                </p>
                <div className="space-y-2 mb-6">
                  {['Parking stalls & ADA-accessible spaces','Fire lanes & directional arrows','New layouts & full restriping','Standalone or add-on to sealcoating'].map((f,i) => (
                    <div key={i} className="flex items-center gap-2 text-gray-300 text-sm">
                      <i className="ri-checkbox-circle-line text-orange-500 flex-shrink-0"></i>{f}
                    </div>
                  ))}
                </div>
                <a href="#contact" className="text-orange-500 hover:text-orange-400 font-bold text-sm flex items-center gap-2 transition-colors">
                  Get Free Quote <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-r from-orange-600 to-orange-500 rounded-2xl p-12 text-center">
          <h3 className="font-display text-5xl font-bold text-white uppercase mb-4">Ready to Protect Your Pavement?</h3>
          <p className="text-xl text-orange-100 mb-8 max-w-2xl mx-auto">Residential driveways or commercial lots — we serve all of Walworth County and respond within 24 hours.</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="tel:262-215-0688" className="bg-white text-orange-600 px-8 py-4 rounded-lg text-lg font-bold hover:bg-gray-50 transition-all inline-flex items-center justify-center gap-2">
              <i className="ri-phone-fill"></i>Call (262) 215-0688
            </a>
            <a href="#contact" className="border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-bold hover:bg-white hover:text-orange-600 transition-all inline-flex items-center justify-center gap-2">
              <i className="ri-calculator-line"></i>Free Estimate Form
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
